module.exports = __webpack_public_path__ + "img/acura.7415f9e1.png";